import { NgxSearchFilterModule } from 'ngx-search-filter';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/shared/material.module';
import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { InstanceConfirmationComponent } from './instance-confirmation/instance-confirmation.component';
import { ConfirmationModalComponent } from './confirmation-modal/confirmation-modal.component';
import { EditOrganizationSaveModalComponent } from './edit-organization-save-modal/edit-organization-save-modal.component';
import { EditUserModalComponent } from './edit-user-modal/edit-user-modal.component';
import { AddUserTypeModalComponent } from './add-user-type-modal/add-user-type-modal.component';
import { UserTypePermissionModalComponent } from './user-type-permission-modal/user-type-permission-modal.component';
import { AddUserForInstanceModalComponent } from './add-user-for-instance-modal/add-user-for-instance-modal.component';
import { HierarchyOptionEditModalComponent } from './hierarchy-option-edit-modal/hierarchy-option-edit-modal.component';
import { ViewHierarchySettingsModalComponent } from './view-hierarchy-settings-modal/view-hierarchy-settings-modal.component';
import { NgJsonEditorModule } from 'ang-jsoneditor';
import { CreateActivityPackModalComponent } from './create-activity-pack-modal/create-activity-pack-modal.component';
import { ViewProjectTypeModalComponent } from './view-project-type-modal/view-project-type-modal.component';
import { CreateActivityPackStatusModalComponent } from './create-activity-pack-status-modal/create-activity-pack-status-modal.component';
import { ColorPickerModule } from 'ngx-color-picker';
import { CreateProjectTypeStatusModalComponent } from './create-project-type-status-modal/create-project-type-status-modal.component';
import { ViewUserForInstanceModalComponent } from './view-user-for-instance-modal/view-user-for-instance-modal.component';
import { OrganizationUserListComponent } from './organization-user-list/organization-user-list.component';
import { AddInstanceModule } from '../../instance/add-instance.module';
import { CreateViewWorkflowStatusComponent } from './create-view-workflow-status/create-view-workflow-status.component';
import { AvatarModule } from 'ngx-avatars';
import { JointCalculationModelComponent } from './joint-calculation-model/joint-calculation-model.component';
import { InformateModule } from 'src/app/Modules/informate/informate.module';
import { SettingsModule } from 'src/app/Modules/settings/settings.module';
import { FileUploadModule } from 'primeng/fileupload';
import { NgbCarouselModule } from '@ng-bootstrap/ng-bootstrap';
import { ViewHierarchyDetailsComponent } from './view-hierarchy-details/view-hierarchy-details.component';
import { ImageCropperModule } from 'ngx-image-cropper';
import { ImageCropModelComponent } from './image-crop-model/image-crop-model.component';
import { TranslocoModule } from '@jsverse/transloco';
import { ToolSelectionComponent } from './tool-selection/tool-selection.component';
import { ScanBarcodeComponent } from './scan-barcode/scan-barcode.component';
import { DxColorBoxModule, DxDateBoxModule } from 'devextreme-angular';
import { SharedModule } from 'src/app/shared/shared.module';
@NgModule({
    declarations: [
        InstanceConfirmationComponent,
        ConfirmationModalComponent,
        EditOrganizationSaveModalComponent,
        EditUserModalComponent,
        AddUserTypeModalComponent,
        UserTypePermissionModalComponent,
        AddUserForInstanceModalComponent,
        HierarchyOptionEditModalComponent,
        ViewHierarchySettingsModalComponent,
        CreateActivityPackModalComponent,
        ViewProjectTypeModalComponent,
        CreateActivityPackStatusModalComponent,
        CreateProjectTypeStatusModalComponent,
        ViewUserForInstanceModalComponent,
        OrganizationUserListComponent,
        CreateViewWorkflowStatusComponent,
        JointCalculationModelComponent,
        ViewHierarchyDetailsComponent,
        ImageCropModelComponent,
        ToolSelectionComponent,
        ScanBarcodeComponent,
    ],
    imports: [
        CommonModule,
        MaterialModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule,
        NgxSearchFilterModule,
        NgJsonEditorModule,
        ColorPickerModule,
        AddInstanceModule,
        AvatarModule,
        InformateModule,
        SettingsModule,
        FileUploadModule,
        NgbCarouselModule,
        ImageCropperModule,
        TranslocoModule,
        DxColorBoxModule,
        DxDateBoxModule,
        SharedModule,
    ],
    exports: [InstanceConfirmationComponent, ConfirmationModalComponent, EditOrganizationSaveModalComponent, JointCalculationModelComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ModalsModule {}
